/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PostOPRecoveryRecord from './post-op-recovery-record';
import PostOPRecoveryRecordDetail from './post-op-recovery-record-detail';
import PostOPRecoveryRecordUpdate from './post-op-recovery-record-update';
import PostOPRecoveryRecordDeleteDialog from './post-op-recovery-record-delete-dialog';

const PostOPRecoveryRecordRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PostOPRecoveryRecord />} />
    <Route path="new" element={<PostOPRecoveryRecordUpdate />} />
    <Route path=":id">
      <Route index element={<PostOPRecoveryRecordDetail />} />
      <Route path="edit" element={<PostOPRecoveryRecordUpdate />} />
      <Route path="delete" element={<PostOPRecoveryRecordDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PostOPRecoveryRecordRoutes;
